/**
 * Имя человека для обращения.
 *
 * Лежит в `shared/`, а не у сервера, потому что правило нужно **обоим**: сервер
 * решает им, называть человека по имени или нет, а экран ввода должен показать
 * то же самое заранее. Иначе получается тихая ложь: поле говорит «годится», а
 * сервер имя выбрасывает, и обращения в раскладе нет без всякого объяснения.
 *
 * Правило намеренно строгое. Имя приходит из Telegram, Google или поля
 * регистрации — то есть это **чужой текст внутри наших инструкций модели**, и
 * фильтр здесь заодно обезвреживает «имя» вида «Ignore all previous
 * instructions…»: от него останется одно слово «Ignore», и оно ничего не значит.
 */

/**
 * Первое слово, только буквы (плюс апостроф и дефис — «Анна-Мария», «D'Arcy»),
 * от 2 до 20 знаков. Иначе `null` — обращения не будет.
 *
 * Фамилия отбрасывается сознательно: «Ferid Isgenderli» → «Ferid». В обращении
 * нужно имя, а не паспортные данные.
 */
export function addressName(raw: string | undefined): string | null {
  const first = (raw ?? '').trim().split(/\s+/)[0] ?? ''
  const letters = [...first].filter((ch) => /[\p{L}'-]/u.test(ch)).join('')
  const len = [...letters].length
  return len >= 2 && len <= 20 ? letters : null
}
